<template>
    <div v-if="ssoEnabled" class="sso-section">
        <div v-for="socialLogin in ssos" :key="socialLogin">
            <secondary-btn
                v-if="socialLoginEnabled(socialLogin)"
                class="d-block sso-btn mt-2 mt-md-3"
                :loading="loadingSso"
                :disabled="loadingSso"
                @click.native="goToSocialLogin(socialLogin)"
            >
                {{ socialLoginLabel(socialLogin) }}
            </secondary-btn>
        </div>
        <p class="or-separator mt-3 mb-0">OR</p>
    </div>
</template>

<script>
import { get } from "vuex-pathify";
import SecondaryBtn from "Components/Buttons/SecondaryBtn";
import lodashGet from "lodash/get";
import lodashIsNil from "lodash/isNil";
import lodashIsEmpty from "lodash/isEmpty";
import lodashFind from "lodash/find";

export default {
    name: "SocialLogins",
    components: {
        SecondaryBtn,
    },
    data() {
        return {
            loadingSso: false,
            // TODO: Update verbiage to match what nissan uses
            socialLogins: [
                {
                    id: "nna",
                    label: "Sign in with MyNISSAN",
                },
            ],
        };
    },
    computed: {
        environments: get("context/environments"),
        ssos: get("campaign/ssos"),
        ssoEnabled() {
            return !lodashIsEmpty(this.ssos);
        },
    },
    methods: {
        goToSocialLogin(providerId) {
            this.$carsaverEventTracker("signInMyNissan");
            this.loadingSso = true;
            document.location = `/sso/${providerId}`;
        },
        socialLoginEnabled(providerId) {
            return !lodashIsNil(lodashFind(this.socialLogins, { id: providerId }));
        },
        socialLoginLabel(providerId) {
            return lodashGet(lodashFind(this.socialLogins, { id: providerId }), "label");
        },
    },
};
</script>

<style lang="scss" scoped>
.sso-section {
    .sso-btn {
        box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.4);
        width: 100%;
    }
    .or-separator {
        font-size: px2rem(12);
        color: $gray-700;
        width: 100%;
        text-align: center;
    }
}
</style>
